import React, { HTMLAttributes } from 'react';
import { Button } from '../Button';

export interface DefaultModalDialogProps extends HTMLAttributes<HTMLElement> {
  /** Attach a custom class to the input container */
  className?: string;
  /** Children to be displayed in the modal body */
  children?: string | string[] | React.ReactNode;
  /** title on the modal */
  title?: string;
  /** text for primary cta (leave blank if no primary cta)*/
  primaryText?: string;
  /** callback for primary cta */
  primaryCallback?: () => void;
  /** is the primary button disabled? */
  primaryDisabled?: boolean;
  /** text for secondary cta (leave blank if no secondary cta)*/
  secondaryText?: string;
  /** callback for primary cta */
  secondaryCallback?: () => void;
  /** is the secondary button disabled? */
  secondaryDisabled?: boolean;
  /** custom footer element if you'd like to use your own */
  customFooter?: JSX.Element;
}

/** Default dialog component */
const DefaultModalDialog = (props: DefaultModalDialogProps) => {

  const {
    children,
    customFooter,
    primaryCallback,
    primaryDisabled,
    primaryText,
    secondaryCallback,
    secondaryDisabled,
    secondaryText,
    title
  } = props;

  return (
    <div className='ps-modal__dialog--default'>
      <h2 className='ps-modal__title'>{title}</h2>
      <div className='ps-modal__children'>{children}</div>
        {customFooter ? customFooter :
         (
          <div className='ps-modal__footer'>
            {secondaryText && secondaryCallback &&
              <Button variant="secondary" onClick={secondaryCallback} className='ps-modal__secondary-cta' disabled={secondaryDisabled}>
                {secondaryText}
              </Button>}
            {primaryText && primaryCallback &&
              <Button variant="primary" onClick={primaryCallback} className='ps-modal__primary-cta' disabled={primaryDisabled}>
                {primaryText}
              </Button>}
          </div>
         )
        }
    </div>
  );
};

DefaultModalDialog.displayName = 'DefaultModalDialog';
export { DefaultModalDialog };